<div class="payment__item" [ngClass]="{ selected: item()?.selected }">
	<div><img [src]="item()?.icon" alt="{{ item()?.name }}" /></div>
	<div>{{ item()?.name }}</div>
</div>
